import { Box, Divider, Heading, Text } from '@chakra-ui/react'
import { useThemeColors } from '@/hooks/useThemeColors'

export function FormPanel({
  title,
  subtitle,
  children,
  variant = 'default',
}: {
  title?: string
  subtitle?: string
  children: React.ReactNode
  /** Compact panel styling aligned to consolidated form mockup */
  variant?: 'default' | 'mockup'
}) {
  const colors = useThemeColors()
  const isMockup = variant === 'mockup'
  return (
    <Box
      bg={isMockup ? colors.cardBg : colors.cardBg}
      borderWidth={isMockup ? '0.5px' : '1px'}
      borderColor={isMockup ? (colors.borderLight ?? colors.border) : colors.border}
      borderRadius="lg"
      p={isMockup ? '14px 16px' : { base: 4, md: 5 }}
      shadow={isMockup ? 'none' : 'sm'}
    >
      {title ? (
        isMockup ? (
          <Text fontSize="12px" fontWeight="500" color={colors.textSecondary} mb={2}>
            {title}
          </Text>
        ) : (
          <Heading size="sm" fontWeight="700" color={colors.heading} mb={subtitle ? 1 : 4}>
            {title}
          </Heading>
        )
      ) : null}
      {subtitle && !isMockup ? (
        <Text fontSize="sm" color={colors.textSecondary} mb={4}>
          {subtitle}
        </Text>
      ) : null}
      {children}
    </Box>
  )
}

/** 11px tertiary label used in the consolidated form mockup */
export function MockupFieldLabel({ children }: { children: React.ReactNode }) {
  const colors = useThemeColors()
  return (
    <Text
      as="label"
      display="block"
      fontSize="11px"
      color={colors.textMuted}
      mb="2px"
      fontWeight="500"
    >
      {children}
    </Text>
  )
}

export function FormDivider() {
  const colors = useThemeColors()
  return <Divider my={5} borderColor={colors.borderLight} />
}

export function FormSubheading({ children }: { children: React.ReactNode }) {
  const colors = useThemeColors()
  return (
    <Text
      fontSize="xs"
      fontWeight="700"
      color={colors.textMuted}
      textTransform="uppercase"
      letterSpacing="wider"
      mb={3}
    >
      {children}
    </Text>
  )
}
